import { hydrateRoot, createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import App from "./App";
import "./index.css";
import "./i18n";
import { initErrorMonitoring } from "./lib/error-monitoring";
import { loadCmsTranslations } from "./lib/cms-translations";
import { registerSW } from "virtual:pwa-register";

initErrorMonitoring();
void loadCmsTranslations();

const container = document.getElementById("root");

function hasPrerenderedMarkup(root: HTMLElement): boolean {
  return Array.from(root.childNodes).some((node) => {
    if (node.nodeType === Node.COMMENT_NODE) return false;
    if (node.nodeType === Node.TEXT_NODE) return (node.textContent ?? "").trim().length > 0;
    return true;
  });
}

const app = (
  <HelmetProvider>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </HelmetProvider>
);

if (container && hasPrerenderedMarkup(container)) {
  hydrateRoot(container, app);
} else if (container) {
  // fallback.html leaves a comment in #root. Hydrating that mismatches and
  // delays the first interactive render on deep links.
  createRoot(container).render(app);
}

window.addEventListener("load", () => {
  registerSW({ immediate: false });
});
